import types from "../../../constants/action-types";

export const setToken = (payload) => ({
  type: types.SET_TOKEN,
  payload,
});
export const setPermissions = (payload) => ({
  type: types.SET_PERMISSIONS,
  payload,
});
export const setRole = (payload) => ({
  type: types.SET_ROLE,
  payload,
});
export const setUsername = (payload) => ({
  type: types.SET_USERNAME,
  payload,
});
export const clearToken = () => {
  localStorage.removeItem("premiumsoft_access_token");
  localStorage.removeItem("role");
  localStorage.removeItem("username");
  return {
    type: types.CLEAR_TOKEN,
  };
};
